import api from './config'

import { ExpenseItem } from './expense'
import { IncomeParentCategory } from '@/types/income'
import { ExpenseParentCategory } from '@/types/expense'

export interface DashboardCategories {
  incomes: Partial<Record<IncomeParentCategory, number>>
  expenses: Partial<Record<ExpenseParentCategory, number>>
}

export interface MonthlyBreakdown {
  month: number
  income: number
  expenses: number
}

export interface DashboardResponse {
  net: number
  bruto: number
  expenses: number
  commission_items: ExpenseItem[]
  vat_items: ExpenseItem[]
  categories: DashboardCategories
  months_active?: number
  months_breakdown: MonthlyBreakdown[]
}

interface DashboardParams {
  year: number
}

/**
 * API returns inverse net and bruto values.
 * sorry need to do round trip of deployments to fix.
 * */
const dashboardAPI = {
  show: async ({ year }: DashboardParams) => {
    const response = await api.get<DashboardResponse>(`/dashboard?year=${year}`)
    return response.data
  }
}

export default dashboardAPI